module.exports = __webpack_public_path__ + "static/media/dialogduk1.fe4a4687.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dialogduk/static/dialogduk1.png
// module id = 163
// module chunks = 0